import { StringParam, useQueryParams } from 'use-query-params'

export const useCandidateDetailsQueryParams = () => {
  const [queryParams, setQueryParams] = useQueryParams({
    previewTask: StringParam,
    taskTemplateName: StringParam
  })

  const resetQueryParams = () => {
    setQueryParams({ previewTask: undefined, taskTemplateName: undefined })
  }

  return { queryParams, setQueryParams, resetQueryParams }
}
